// extracted by mini-css-extract-plugin
module.exports = {"root":"Step-root-zs_v7","text":"Step-text-_Hv86"};